module.exports = __webpack_public_path__ + "static/media/West.35ffde5d.jpeg";